<script setup lang="ts">
import PanelGroup from '../../PanelGroup.vue'
import ImageField from '../../ImageField.vue'
import useBrandAppConfig from '../../../composables/useBrandAppConfig'

const { t } = useI18n()
const { home, updateHome } = useBrandAppConfig()
</script>

<template>
  <PanelGroup>
    <ImageField
      id="brandApp.home.heroImage"
      :model-value="home.heroImage"
      :help="t('pages.loyaltySupports.webapp.editor.hero.imageHelp')"
      @update:model-value="updateHome('heroImage', $event)"
    />
  </PanelGroup>
</template>
